// src/services/CommentAdminService.js

import http from "./httpService";

class CommentAdminService {
  async getAll(params) {
    const url = http.getUrlWithParams("/admin/comment", params);
    return await http.get(url);
  }
}

export default new CommentAdminService();
